import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  const safeReturnUrl = authService.sanitizeReturnUrl(state.url);
  if (safeReturnUrl && safeReturnUrl !== '/home') {
    return router.createUrlTree(['/'], { queryParams: { returnUrl: safeReturnUrl } });
  }
  return router.parseUrl('/');
};
